import { Controller } from "@hotwired/stimulus"
import { Modal } from "../utils/modal"

export default class extends Controller {
  static targets = ["llmCheckbox", "authCheckbox"]

  toggle(event) {
    const clickedCheckbox = event.target;
    const groupMap = {
      "llm-module-checkbox": this.llmCheckboxTargets,
      "auth-module-checkbox": this.authCheckboxTargets
    };

    Object.entries(groupMap).forEach(([className, targets]) => {
      if (clickedCheckbox.classList.contains(className) && clickedCheckbox.checked) {
        targets.forEach(checkbox => {
          if (checkbox !== clickedCheckbox) {
            checkbox.checked = false;
          }
        });
      }
    });
  }

  handleSubmit(event) {
    const checkboxes = this.element.querySelectorAll('input[type="checkbox"][name="project[enabled_modules][]"]');
    const previouslyChecked = Array.from(checkboxes).filter(cb => cb.defaultChecked).map(cb => cb.value).sort();
    const currentlyChecked = Array.from(checkboxes).filter(cb => cb.checked).map(cb => cb.value).sort();
    // Only if we change a project we should show any warning, otherwise it's a new one.
    const patch = event.target.querySelector('input[name="_method"]')?.value === "patch";
    // Show warning if any module selection has changed (checked or unchecked)
    const changed = previouslyChecked.length !== currentlyChecked.length || previouslyChecked.some((val, idx) => val !== currentlyChecked[idx]);

    if (patch && changed) {
      event.preventDefault();

      Modal.danger({
        title: window.I18n.modal.danger.title,
        message: window.I18n.notifications.module_selection_changed,
        confirmText: window.I18n.general.okay,
        cancelText: window.I18n.general.cancel,
        onConfirm: () => {event.target.submit()},
        onCancel: () => {
          return false;
        }
      });
    }
  }
} 